<template>
  <button
    type="button"
    class="relative inline-flex items-center justify-center rounded-full px-3 py-1 font-medium text-primary hover:bg-primary/8 focus:outline-none"
  >
    <IconHeroiconsSolidPlus class="mr-2" />
    <slot> Create New </slot>
  </button>
</template>
